export function registerAdditionalRules() {
    $("#dobHidden").rules("add", {
        over18: true,
        required: true,
    });

    // Validation rules based on input id - these inputs do not have unique names
    $("#postcodeUK").rules("add", {
        postcodeUK: true,
        required: true,
    });

    // DE postcode
    $("#postcodeDE").rules("add", {
        postcodeDE: true,
        required: true,
    });

    // AT postcode
    $("#postcodeAT").rules("add", {
        postcodeAT: true,
        required: true,
    });

    // UK phone
    $("#phoneUK").rules("add", {
        phoneWithOptionalZeroPrefixUK: true,
        required: true,
    });

    // DEAT phone
    $("#phoneDEAT").rules("add", {
        phoneWithOptionalZeroPrefixDEAT: true,
        required: true,
    });

    $(".currency").rules("add", {
        required: true,
        minimum: 100,
        maximum: 10000,
    });
}
